<script>
    export let title;
</script>

<div class="display-4 bold text-center text">{title}</div>
<div class="text-center text">
    <slot></slot>
</div>